(() => {
  'use strict';

  const SELECTOR = '[data-lpcontact]';

  class LPContactConversions {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.lpcontact__form');
      this.message = root.querySelector('[data-lpcontact-message]');
      this.count = root.querySelector('[data-lpcontact-count]');
      this.submit = root.querySelector('[data-lpcontact-submit]');
      this.submitLabel = root.querySelector('[data-lpcontact-submit-label]');
      this.success = root.querySelector('[data-lpcontact-success]');
      this.errors = root.querySelector('[data-lpcontact-errors]');
      this.abortController = new AbortController();
      this.originalSubmitLabel = this.submitLabel?.textContent || '';

      this.onInput = this.onInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.bind();
      this.updateCount();
      this.focusNotice();
    }

    bind() {
      if (this.message) {
        this.message.addEventListener('input', this.onInput, {
          signal: this.abortController.signal
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit, {
          signal: this.abortController.signal
        });
      }
    }

    destroy() {
      this.abortController.abort();
    }

    onInput() {
      this.updateCount();
    }

    updateCount() {
      if (!this.message || !this.count) return;

      const max = Number(this.message.getAttribute('maxlength')) || 0;
      const current = this.message.value.length;
      this.count.textContent = `${current} / ${max}`;
      this.count.classList.toggle('is-near-limit', max > 0 && current >= max * 0.9);
    }

    onSubmit() {
      if (!this.submit || !this.form) return;

      if (!this.form.checkValidity()) {
        return;
      }

      this.submit.disabled = true;
      this.submit.classList.add('is-loading');
      this.submit.setAttribute('aria-busy', 'true');

      if (this.submitLabel) {
        this.submitLabel.textContent = 'Sending…';
      }

      window.setTimeout(() => {
        if (!this.submit) return;
        this.submit.disabled = false;
        this.submit.classList.remove('is-loading');
        this.submit.removeAttribute('aria-busy');

        if (this.submitLabel) {
          this.submitLabel.textContent = this.originalSubmitLabel;
        }
      }, 12000);
    }

    focusNotice() {
      const notice = this.success || this.errors;
      if (!notice) return;

      requestAnimationFrame(() => {
        notice.focus({ preventScroll: true });
        notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  const instances = new WeakMap();

  function init(scope = document) {
    scope.querySelectorAll?.(SELECTOR).forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new LPContactConversions(root));
    });
  }

  function destroy(scope) {
    scope.querySelectorAll?.(SELECTOR).forEach((root) => {
      instances.get(root)?.destroy();
      instances.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
